import { render } from "./YourMovie.vue?vue&type=template&id=0fbc11f3"
import script from "./YourMovie.vue?vue&type=script&lang=js"
export * from "./YourMovie.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__